export function toggleMenu() {
    setTimeout(() => {
        const buttonDropdown = document.querySelectorAll("[data-action='open-dropdown']")
        
        buttonDropdown.forEach((item, index) => {
            buttonDropdown[index].addEventListener("click", (e) => {
                buttonDropdown[index].classList.toggle("active")
                buttonDropdown[index].nextSibling.nextElementSibling.classList.toggle("open")
            })
        })
    }, 100)
}
